import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class JournalDeleteController extends Controller {
  @service fundsService;
  @service journalService;
  @service router;

  @tracked error = null;
  @tracked saving = false;

  get journal() {
    return this.model.journalInfo.journal;
  }

  @action
  templateDidInsert() {
    this.error = null;
    this.deleting = false;
  }

  @action
  async delete() {
    this.deleting = true;
    try {
      await this.fundsService.confirmValidFundToken();
      await this.journal.destroyRecord();
      await this.journalService.load({ forceReload: true });
      this.router.transitionTo('funds.fund.journals');
    } catch (error) {
      this.error = error;
    }
    this.deleting = false;
  }
}
